
export default  [
   
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'nome',
        label: 'Nome',
        maxlength:255,
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'descricao',
        label: 'Descrição',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'boolean',
        field: 'ativo',
        label: 'Registro Ativo?',
        rules: ['required']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/configuracao/conclusao-tecnica/_form/conclusao-cadastrar.js